import { observable, action, makeObservable } from 'mobx';

class ModalParams {
	@observable isOpen = false;
	@observable loading = false;
	@observable data = {};
	onClose = null;
	onOpen = null;
	onSuccess = null;
	component = null;

	constructor({ ...props }) {
		makeObservable(this);
		Object.assign(this, props);
	}

	@action.bound
	open(data) {
		if (this.isOpen) return;
		this.data = data;
		this.setOpen(true);
		if (this.onOpen) {
			this.onOpen();
		}
	}

	@action.bound
	close = (params = null) => {
		if (!this.isOpen) return;
		this.setOpen(false);
		if (this.onClose) {
			this.onClose(params);
		}
	};

	@action.bound
	success = (params = null) => {
		this.setOpen(false);
		if (this.onSuccess) {
			this.onSuccess(params);
		}
	};

	@action.bound
	setOpen = value => {
		this.isOpen = value;
	};
}

export default ModalParams;



// WEBPACK FOOTER //
// ./src/core/models/ModalParams.js